import React, { Component } from "react";
import style from "./Blog.module.scss";

class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coverFileName: "",
    };
  }

  getMissingFields = () => {
    const {
      blogCondition,
      blogTitle,
      blogSubTitle,
      blogAuthor,
      source,
      selectedRadioOption,
      blogImgUrl,
      image,
      hasContent,
    } = this.props;

    if (!blogCondition) return [];

    const missing = [];
    if (!blogTitle) missing.push("Title");
    if (!blogSubTitle) missing.push("Subtitle");
    if (!blogAuthor) missing.push("Author");
    if (!source) missing.push("Source / Brand");
    if (!(selectedRadioOption === "Yes" ? blogImgUrl : image)) {
      missing.push("Cover image");
    }
    if (hasContent === false) missing.push("Blog content (right panel)");
    return missing;
  };

  render() {
    const {
      handleBlogTextChange,
      selectedRadioOption,
      radioChange,
      onUpload,
      blogImgUrl,
      onError,
      onSaveBlog,
      imageURlErrored,
      imageError,
      blogCondition,
      onUploadMultiImages,
      onSourceChange,
      image,
      faqs,
      onAddFaq,
      onRemoveFaq,
      onFaqChange,
      blogTitle,
      blogSubTitle,
      blogAuthor,
      blogMetaTitle,
      blogMetaDescription,
      blogKeywords,
      blogSlug,
      source,
      blogList,
      blogListLoading,
      blogContentLoading,
      blogMode,
      editingBlogId,
      onOpenBlog,
      onNewBlog,
      onRefreshBlogList,
    } = this.props;

    const imageMode = selectedRadioOption || "No";
    const coverPreview = imageMode === "Yes" ? blogImgUrl : image;
    const missing = this.getMissingFields();
    const isEdit = blogMode === "edit";
    const blogs = blogList || [];

    return (
      <div className={style.form}>
        <header className={style.header}>
          <p className={style.eyebrow}>Admin · Blogs</p>
          <h1 className={style.title}>
            {isEdit ? "Edit Blog Post" : "Create Blog Post"}
          </h1>
          <p className={style.subtitle}>
            Pick a source to list blogs, open one to edit, or create a new post.
          </p>
        </header>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <h2 className={style.sectionTitle}>0. Browse blogs</h2>
            <p className={style.sectionHint}>
              Select a source, then open a blog to load it into the form.
            </p>
          </div>

          <div className={style.field}>
            <label className={style.label} htmlFor="caseDropdown">
              Source <span className={style.required}>*</span>
            </label>
            <select
              id="caseDropdown"
              className={style.select}
              value={source || ""}
              onChange={(e) => onSourceChange(e.target.value)}
            >
              <option value="">Select source</option>
              <option value="smallcase">Smallcase</option>
              <option value="trilithon">Trilithon</option>
              <option value="LDR">LDR</option>
              <option value="pms">PMS</option>
            </select>
          </div>

          <div className={style.listToolbar}>
            <button
              type="button"
              className={style.secondaryBtn}
              onClick={onNewBlog}
            >
              + New blog
            </button>
            <button
              type="button"
              className={style.secondaryBtn}
              onClick={onRefreshBlogList}
              disabled={!source || blogListLoading}
            >
              {blogListLoading ? "Loading…" : "Refresh list"}
            </button>
          </div>

          {!source && (
            <p className={style.emptyHint}>Select a source to load blogs.</p>
          )}

          {source && blogListLoading && (
            <p className={style.emptyHint}>Fetching blogs…</p>
          )}

          {source && blogContentLoading && (
            <p className={style.emptyHint}>Opening blog content…</p>
          )}

          {source && !blogListLoading && blogs.length === 0 && (
            <p className={style.emptyHint}>No blogs found for this source.</p>
          )}

          {source && blogs.length > 0 && (
            <ul className={style.blogList}>
              {blogs.map((blog) => {
                const active =
                  isEdit &&
                  ((editingBlogId != null && blog.id === editingBlogId) ||
                    blog.title === blogTitle);
                return (
                  <li key={blog.id || blog.slug || blog.title}>
                    <button
                      type="button"
                      className={`${style.blogItem} ${
                        active ? style.blogItemActive : ""
                      }`}
                      onClick={() => onOpenBlog(blog)}
                    >
                      <span className={style.blogItemTitle}>
                        {blog.title}
                      </span>
                      <span className={style.blogItemMeta}>
                        {blog.updated_on || "—"}
                        {blog.author ? ` · ${blog.author}` : ""}
                      </span>
                      {blog.slug && (
                        <span className={style.blogItemSlug}>{blog.slug}</span>
                      )}
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </section>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <h2 className={style.sectionTitle}>1. Blog details</h2>
            <p className={style.sectionHint}>
              Basic info readers see on the post.
              {isEdit && editingBlogId != null
                ? ` Editing #${editingBlogId}`
                : ""}
            </p>
          </div>

          <div className={style.field}>
            <label className={style.label} htmlFor="title">
              Title <span className={style.required}>*</span>
            </label>
            <input
              className={style.input}
              type="text"
              id="title"
              name="title"
              value={blogTitle || ""}
              placeholder="e.g. How to invest in SIPs"
              onChange={(e) => handleBlogTextChange(e, "title")}
            />
          </div>

          <div className={style.field}>
            <label className={style.label} htmlFor="sub_title">
              Subtitle <span className={style.required}>*</span>
            </label>
            <input
              className={style.input}
              type="text"
              id="sub_title"
              name="sub_title"
              value={blogSubTitle || ""}
              placeholder="Short summary under the title"
              onChange={(e) => handleBlogTextChange(e, "sub_title")}
            />
          </div>

          <div className={style.field}>
            <label className={style.label} htmlFor="author">
              Author <span className={style.required}>*</span>
            </label>
            <select
              className={style.select}
              id="author"
              name="author"
              value={blogAuthor || ""}
              onChange={(e) => handleBlogTextChange(e, "author")}
            >
              <option value="">Select author</option>
              <option value="Abhishek Banerjee">Abhishek Banerjee</option>
              <option value="Lotusdew Research">Lotusdew Research</option>
              <option value="Trilithon Research">Trilithon Research</option>
              {blogAuthor &&
                ![
                  "Abhishek Banerjee",
                  "Lotusdew Research",
                  "Trilithon Research",
                ].includes(blogAuthor) && (
                  <option value={blogAuthor}>{blogAuthor}</option>
                )}
            </select>
          </div>
        </section>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <h2 className={style.sectionTitle}>2. SEO (optional but recommended)</h2>
            <p className={style.sectionHint}>
              Helps search engines find this post.
            </p>
          </div>

          <div className={style.field}>
            <label className={style.label} htmlFor="meta_title">
              Meta title
            </label>
            <input
              className={style.input}
              type="text"
              id="meta_title"
              name="meta_title"
              value={blogMetaTitle || ""}
              placeholder="SEO title (≈ 50–60 chars)"
              onChange={(e) => handleBlogTextChange(e, "meta_title")}
            />
          </div>

          <div className={style.field}>
            <label className={style.label} htmlFor="meta_description">
              Meta description
            </label>
            <textarea
              className={style.textarea}
              id="meta_description"
              name="meta_description"
              value={blogMetaDescription || ""}
              placeholder="1–2 sentences for search results"
              rows={3}
              onChange={(e) => handleBlogTextChange(e, "meta_description")}
            />
          </div>

          <div className={style.field}>
            <label className={style.label} htmlFor="slug">
              Slug
            </label>
            <input
              className={style.input}
              type="text"
              id="slug"
              name="slug"
              value={blogSlug || ""}
              placeholder="e.g. how-to-invest-in-sips"
              onChange={(e) => handleBlogTextChange(e, "slug")}
            />
            <p className={style.fieldHint}>
              Used in the blog URL. Auto-filled from the title; edit to override.
            </p>
          </div>

          <div className={style.field}>
            <label className={style.label} htmlFor="keywords">
              Keywords
            </label>
            <input
              className={style.input}
              type="text"
              id="keywords"
              name="keywords"
              value={blogKeywords || ""}
              placeholder="sip, investing, mutual funds"
              onChange={(e) => handleBlogTextChange(e, "keywords")}
            />
          </div>
        </section>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <h2 className={style.sectionTitle}>
              3. Cover image <span className={style.required}>*</span>
            </h2>
            <p className={style.sectionHint}>
              Main image shown at the top of the blog.
            </p>
          </div>

          <div className={style.segmented}>
            <label className={style.segment}>
              <input
                type="radio"
                value="No"
                name="coverMode"
                checked={imageMode === "No"}
                onChange={radioChange}
              />
              <span className={style.segmentFace}>
                <span className={style.segmentTitle}>Upload file</span>
                <span className={style.segmentDesc}>PNG or JPG, max 3 MB</span>
              </span>
            </label>

            <label className={style.segment}>
              <input
                type="radio"
                value="Yes"
                name="coverMode"
                checked={imageMode === "Yes"}
                onChange={radioChange}
              />
              <span className={style.segmentFace}>
                <span className={style.segmentTitle}>Use image URL</span>
                <span className={style.segmentDesc}>Paste a public link</span>
              </span>
            </label>
          </div>

          {imageMode === "Yes" && (
            <div className={style.field}>
              <label className={style.label} htmlFor="url">
                Image URL
              </label>
              <input
                className={style.input}
                type="text"
                id="url"
                name="url"
                value={blogImgUrl || ""}
                placeholder="https://example.com/cover.jpg"
                onChange={(e) => handleBlogTextChange(e, "url")}
              />
              {imageURlErrored && (
                <p className={style.error}>Please enter a valid image URL.</p>
              )}
            </div>
          )}

          {imageMode === "No" && (
            <label className={style.dropzone} htmlFor="upload">
              <p className={style.dropzoneTitle}>
                {this.state.coverFileName
                  ? "Replace cover image"
                  : "Click to upload cover"}
              </p>
              <p className={style.dropzoneHint}>
                PNG, JPEG or JPG · under 3 MB
              </p>
              <input
                className={style.hiddenFile}
                type="file"
                id="upload"
                accept=".png,.jpg,.jpeg,image/png,image/jpeg"
                onChange={(e) => {
                  const file = e.target.files && e.target.files[0];
                  this.setState({
                    coverFileName: file ? file.name : "",
                  });
                  onUpload(e);
                }}
              />
            </label>
          )}

          {imageError && imageMode === "No" && (
            <p className={style.error}>
              File must be PNG, JPEG or JPG and less than 3 MB.
            </p>
          )}

          {coverPreview && !imageURlErrored && (
            <div className={style.preview}>
              <img
                className={style.previewImg}
                src={coverPreview}
                onError={onError}
                alt="Cover preview"
              />
              <div className={style.previewMeta}>
                <span>
                  {this.state.coverFileName ||
                    (imageMode === "Yes" ? "From URL" : "Uploaded")}
                </span>
                <span className={style.previewBadge}>Ready</span>
              </div>
            </div>
          )}

          {imageMode === "Yes" && blogImgUrl && (
            <img
              src={blogImgUrl}
              onError={onError}
              width="1"
              height="1"
              style={{ display: "none" }}
              alt=""
            />
          )}
        </section>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <h2 className={style.sectionTitle}>4. Insert images into content</h2>
            <p className={style.sectionHint}>
              Optional. Adds images into the blog body editor on the right.
            </p>
          </div>

          <label className={style.dropzone} htmlFor="upload_imgs">
            <p className={style.dropzoneTitle}>Upload content images</p>
            <p className={style.dropzoneHint}>
              You can select multiple PNG / JPG files
            </p>
            <input
              className={style.hiddenFile}
              onChange={(e) => onUploadMultiImages(e)}
              type="file"
              id="upload_imgs"
              name="upload_imgs[]"
              accept=".png,.jpg,.jpeg,image/png,image/jpeg"
              multiple
            />
          </label>
        </section>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <h2 className={style.sectionTitle}>5. FAQs (Optional)</h2>
            <p className={style.sectionHint}>
              Add frequently asked questions and answers for this blog.
            </p>
          </div>

          {faqs &&
            faqs.length > 0 &&
            faqs.map((faq, index) => (
              <div key={index} className={style.faqCard}>
                <div className={style.faqHeader}>
                  <span className={style.faqNumber}>FAQ #{index + 1}</span>
                  <button
                    type="button"
                    className={style.removeFaqBtn}
                    onClick={() => onRemoveFaq(index)}
                  >
                    Remove
                  </button>
                </div>

                <div className={style.field}>
                  <label className={style.label} htmlFor={`faq-q-${index}`}>
                    Question
                  </label>
                  <input
                    className={style.input}
                    type="text"
                    id={`faq-q-${index}`}
                    placeholder="e.g. What is the minimum investment?"
                    value={faq.question}
                    onChange={(e) =>
                      onFaqChange(index, "question", e.target.value)
                    }
                  />
                </div>

                <div className={style.field}>
                  <label className={style.label} htmlFor={`faq-a-${index}`}>
                    Answer
                  </label>
                  <textarea
                    className={style.textarea}
                    id={`faq-a-${index}`}
                    placeholder="Write the answer here..."
                    rows={2}
                    value={faq.answer}
                    onChange={(e) =>
                      onFaqChange(index, "answer", e.target.value)
                    }
                  />
                </div>
              </div>
            ))}

          <button type="button" className={style.addFaqBtn} onClick={onAddFaq}>
            + Add FAQ Question & Answer
          </button>
        </section>

        {missing.length > 0 && (
          <div className={style.checklist}>
            <p className={style.checklistTitle}>
              Still needed before {isEdit ? "update" : "publish"}
            </p>
            <ul className={style.checklistList}>
              {missing.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        <button
          type="button"
          className={style.publish}
          onClick={onSaveBlog}
          disabled={blogCondition || blogContentLoading}
        >
          {isEdit ? "Update Blog" : "Publish Blog"}
        </button>
      </div>
    );
  }
}

export default Blog;
